import type { ApolloClient } from '@apollo/client'
import type { ViewQueryList } from '@salescore/core'

import { fetchChildRecordNode } from '../../../recoil/records/mutations/fetchChildNode'
import type { RelationChange } from '../../../recoil/records/mutations/updateRecordNodeRelations'
import { getReferencingNode } from '../../util/getReferencingNode'
import type { RecordChange } from '../../util/updateViewRecords'

export async function searchRelation({
  recordChange,
  client,
  query,
}: {
  recordChange: RecordChange
  client: ApolloClient<unknown>
  query: ViewQueryList | undefined
}): Promise<RelationChange | undefined> {
  if (query === undefined) {
    return undefined
  }
  const { rowIndex, innerRowIndex, value, field } = recordChange
  const referencingNode = getReferencingNode({
    field: recordChange.field,
    queryTree: query.tree,
  })
  if (referencingNode === undefined) {
    return undefined
  }

  const fetchedChildRecordNode = await fetchChildRecordNode(
    referencingNode,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    value as string,
    query,
    client,
    field,
  )
  if (fetchedChildRecordNode === undefined) {
    return undefined
  }

  return {
    node: referencingNode,
    rowIndex,
    innerRowIndex,
    recordNode: fetchedChildRecordNode,
  }
}
